export class BeException extends Error {

  // Make sure this is hard-coded as a string
  // BeException.name will not work in production
  // because class names are changed when minified
  className: string = 'BeException';
  code: number | undefined;
  prev: Error | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message);
    if ((Error as any).captureStackTrace !== undefined) {
      (Error as any).captureStackTrace(this, this.constructor);
    };
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class AuthException extends BeException {

  className: string = 'AuthException';
  lockedUntil: number | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Access denied', code, prev);
  }
}

export class AuthLockedException extends AuthException {

  className: string = 'AuthLockedException';

  constructor(message?: string, code?: number, lockedUntil?: number) {
    super(message, code);
    this.lockedUntil = lockedUntil || undefined;
  }
}

export class AccessDeniedException extends BeException {

  className: string = 'AccessDeniedException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Access denied', code, prev);
  }
}

export class NotFoundException extends BeException {

  className: string = 'NotFoundException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Resource not found', code, prev);
  }
}

export class BadRequestException extends BeException {

  className: string = 'BadRequestException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Bad request', code, prev);
  }
}

export class ValidationException extends BadRequestException {

  className: string = 'ValidationException';

  fields: any;

  constructor(message?: string, fields?: any) {
    super(message);
    this.fields = fields;
  }
}

export class ServerErrorException extends BeException {

  className: string = 'ServerErrorException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Internal server error', code, prev);
  }
}

export class LocalException extends Error {

  className: string = 'LocalException';
  code: number | undefined;
  prev: Error | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message);
    if ((Error as any).captureStackTrace !== undefined) {
      (Error as any).captureStackTrace(this, this.constructor);
    };
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class NetworkErrorException extends LocalException {

  className: string = 'NetworkErrorException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Network error', code, prev);
  }
}

export const ACC_TOKEN_MISSING = 1000;
export const ACC_TOKEN_JWT_EXPIRED = 1002;
export const REF_TOKEN_NOT_FOUND = 1007;
export const REF_TOKEN_EXPIRED = 1009;
export const LOGIN_USER_NOT_FOUND = 1011;
export const LOGIN_INVALID_CREDENTIALS = 1012;
export const USER_NOT_FOUND = 1030;
export const EMAIL_VERIFICATION_INVALID_TOKEN = 1069;
export const PASSWORD_RESET_INVALID_TOKEN = 1070;
export const EMAIL_ALREADY_VERIFIED = 1078;
export const ACCOUNT_ALREADY_ACTIVATED = 1079;
export const MAINTENANCE_ACCESS_NOT_ALLOWED = 1108;
export const MAX_FAILED_AUTH_ATTEMPTS_REACHED = 1116;
export const TFA_TOKEN_MISSING = 1118;
export const TFA_INVALID_TOKEN = 1119;
export const TFA_INVALID_CODE = 1122;
export const TFA_EXPIRED_CODE = 1123;
export const TFA_TOKEN_RESEND_ABUSE = 1124;
export const PASSWORD_RESET_CANNOT_USE_SAME_PASSWORD = 1130;
export const LOGIN_USER_NOT_ACTIVATED = 1142;
export const PASSWORD_RESET_USER_NOT_ACTIVE = 1317;
export const TFA_EXPIRED_TOKEN = 1352;
export const US_REGION_NOT_FOUND = 1415;
